/**
 * Theme sync: 2026-09-03-base
 * jrs-post-add-router.js — Run 3 post-add routing (redirect vs original)
 *
 * Run 3 (2026-09-03 → 2026-09-17) is a two-arm Intelligems CONTENT test on
 * this one published theme — not a theme test.
 *
 *   Arm A (redirect): every completed add navigates to /cart.
 *   Arm B ('modal'):  the ORIGINAL variantaug post-add behaviour, restored
 *                     verbatim (operator ruling 2026-09-02: "get all of our
 *                     old modals back from variant aug theme"). Per path:
 *                     popup confirm / skip-add → the in-popup success-step
 *                     receipt (jrs-v2-customizer-success-step.js — green
 *                     tick, product card, BRANDING SUMMARY, both-outline
 *                     CTAs); legacy customizer notification path → the
 *                     cart-notification-mrk popup (initNotification);
 *                     product-form → the Dawn cart-notification/drawer
 *                     render; standard PDP / sticky / direct-bundle adds →
 *                     redirect (that is what variantaug did on those paths).
 *
 * The switch is ONE mode value, read at ADD TIME inside complete().
 * THEME DEFAULT = 'redirect' (the control-like arm): if the Intelligems
 * variant script fails to load, the visitor fails into the known quantity.
 * The variant script sets the mode and nothing else:
 *
 *   // Intelligems custom JS — Arm B variant ONLY:
 *   window.__jrsPostAddMode = 'modal';
 *
 * complete() pushes ONE `post_add_complete` dataLayer event per add, in
 * BOTH arms, at the same moment — after the add succeeded, BEFORE the
 * routing decision. Params: post_add_mode ('redirect'|'modal'), add_path.
 * NOTE (GTM Run 3 version task): the container's only catch-all matches
 * ^pdp_customizer_ — this event needs its OWN trigger.
 *
 * Contract with callers: complete() returns 'redirect' when it has taken
 * over (navigation is under way — caller must stop) and 'modal' when the
 * caller should proceed with its ORIGINAL post-add surface unchanged.
 *
 * Wired completion sites (every add path):
 *   popup_multistep_confirm / popup_bundle_confirm — jrs-v2-step-review.js
 *   popup_skip_add                                 — jrs-v2-step-intro.js
 *   pdp_standard                                   — jrs-v2-pdp-controller.js
 *   sticky_atc                                     — sticky-atc-reg-pdp.js
 *   bundle_direct                                  — betterconversions-bundle.js
 *   legacy_regular / legacy_notification           — betterconversions-customizer.js
 *   product_form                                   — product-form.js
 */

window.JRS = window.JRS || {};

(function (JRS) {
  'use strict';

  /** Double-wire guard: two handlers on one completion fire within ms of each
      other; two genuine adds cannot complete this close together. */
  var GUARD_MS = 800;
  var _lastCompleteAt = 0;

  /** @returns {'redirect'|'modal'} the mode AT THIS MOMENT (add time). */
  function getMode() {
    return window.__jrsPostAddMode === 'modal' ? 'modal' : 'redirect';
  }

  /**
   * The single post-add completion point. Pushes post_add_complete (both
   * arms, identically, before any routing), then routes per the mode.
   *
   * @param {{path: string}} ctx
   * @returns {'redirect'|'modal'|'suppressed'} 'redirect' = navigation taken
   *   over, caller stops; 'modal' = caller proceeds with its original
   *   variantaug post-add surface; 'suppressed' = double-wire duplicate.
   */
  function complete(ctx) {
    ctx = ctx || {};
    var now = Date.now();
    if (now - _lastCompleteAt < GUARD_MS) return 'suppressed';
    _lastCompleteAt = now;

    var mode = getMode(); // read at ADD time — the one branch point
    var path = String(ctx.path || 'unknown');
    _lastAddPath = path; // join key carried onto post_add_cta_click

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'post_add_complete',
      post_add_mode: mode,
      add_path: path
    });

    if (mode === 'redirect') {
      window.location.href = '/cart';
      return 'redirect';
    }
    // Arm B — the caller shows its original variantaug surface. Arm the CTA
    // tracker ONLY for the surfaces the legacy analytics do NOT cover: the
    // cart-notification popups (legacy_notification / product_form). The
    // popup success-step receipt already fires pdp_customizer_success_action
    // on every exit (view_cart / continue_shopping / checkout / dismissed)
    // through the ^pdp_customizer_ catch-all — attaching a second event
    // there would duplicate coverage on a container that has had two
    // route-doubling defects removed.
    if (path === 'legacy_notification' || path === 'product_form') {
      _awaitCta = true;
    }
    return 'modal';
  }

  // ---------------------------------------------------------------------------
  // post_add_cta_click — the cart-notification surfaces only (arm B)
  // ---------------------------------------------------------------------------
  // One event per modal session: cta = view_cart | continue_shopping | close
  // (the X, the backdrop, and Dawn's Escape are all 'close' — the same
  // outcome: shown but not clicked through, Run 2's 35.7%). add_path carries
  // through from the post_add_complete that opened the surface so the events
  // join. Delegated document-level listeners — ZERO changes to the restored
  // variantaug markup (frozen by ruling). The latch is also the once-per-
  // click / double-wire guard; it re-arms on the next qualifying add.
  // On view_cart the push precedes the <a> navigation in the same task
  // (dataLayer.push is synchronous; GTM is loaded by click time; GA4's
  // beacon transport survives the unload).

  var _awaitCta = false;
  var _lastAddPath = 'unknown';

  function _fireCta(cta) {
    if (!_awaitCta) return;
    _awaitCta = false;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'post_add_cta_click',
      cta: cta,
      add_path: _lastAddPath
    });
  }

  document.addEventListener('click', function (e) {
    if (!_awaitCta || !e.target || !e.target.closest) return;
    var t = e.target;
    if (t.closest('#cart-notification-button')) { _fireCta('view_cart'); return; }
    if (t.closest('.cart-popup__close')) { _fireCta('close'); return; }
    if (t.closest('.cart-popup--wrap-overlay')) { _fireCta('close'); return; }
    if (t.closest('button[type="close"]')) { _fireCta('continue_shopping'); }
  });

  // Dawn's cart-notification closes on Escape ONLY when the keyup lands
  // inside #cart-notification (its own listener scope) — mirror exactly, so
  // the mrk popup (which has no Escape close) never emits a phantom 'close'.
  document.addEventListener('keyup', function (e) {
    if (!_awaitCta || e.code !== 'Escape') return;
    if (e.target && e.target.closest && e.target.closest('#cart-notification')) {
      _fireCta('close');
    }
  });

  JRS.PostAdd = {
    getMode: getMode,
    complete: complete,
    // Test seam.
    _fireCta: _fireCta
  };
})(window.JRS);
